<script setup>
import { reactive, ref, watch, onMounted } from 'vue';
import i18n from "@/i18n"
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import { getHscode, get_user_index_standard, post_user_index_standard, getHscodeDetail } from "@/service/index"
import { showMessage } from "@/utils/hooks/message"
import { getLangValue } from "@/utils/common"; //获取后端语言
const tableInfo = ref([])
const tableAllInfo = ref([])
const table_head = [
    { label: getLangValue("my.account", "indicator_name"), width: '15%', },
    { label: getLangValue("my.account", "indicator_group"), width: '15%', },
    { label: getLangValue("my.account", "reference_standard"), width: '15%', },
    { label: getLangValue("my.account", "detection_price"), width: '15%', },
    { label: getLangValue("my.account", "detection_period"), width: '15%', },
    { label: getLangValue("base.operation"), width: '10%', },
]
const pageSizeOption = [10, 20, 30, 40, 50]
const { total, currentPage, pageSize, pageOption } = usetablePageNation()
const searchData = reactive({
    hscode: [],
    group: '',
});
const hscodeList1 = ref([])
const groupTypeList = ref([])
const selectHscode = ref('')
const valueList = ref([]) //已经提交的数据
const search = () => {
    // 搜索
    currentPage.value = 1;
    getDataList();
}

const reset = () => {
    // 重置
    searchData.hscode = ''
    searchData.group = ''
    groupTypeList.value = []
    selectHscode.value = ''
    // getDataList();
}

const set_key_data = (data) => {
    // 获取所有数据的key 用于筛选
    // 获取所有的指标数据  并插入筛选的key groupTypeName
    let data_all = []
    let key_all = [];
    console.log(data)
    for (const item in data) {
        const { group_name, group_name_en, index_standards, children } = data[item]
        if (index_standards.length) {
            index_standards.forEach(element => {
                element.groupTypeName = group_name
                element.groupTypeName_en = group_name_en
            })
            data_all = [...index_standards, ...data_all]
            key_all.push({
                label: group_name,
                label_en: group_name_en,
                value: group_name,
                count: index_standards.length
            });
        }
        if (children.length) {
            //二级
            for (const item1 in children) {
                const { group_name: group_name1, group_name_en: group_name1_en, index_standards: index_standards1, children: children1 } = children[item1]
                if (index_standards1.length) {
                    // data_all[`${group_name},${group_name1}`] = index_standards1
                    index_standards1.forEach(element => {
                        element.groupTypeName = `${group_name},${group_name1}`
                        element.groupTypeName_en = `${group_name_en},${group_name1_en}`
                    })
                    data_all = [...index_standards1, ...data_all]
                    key_all.push({
                        label: `${group_name},${group_name1}`,
                        label_en: `${group_name_en},${group_name1_en}`,
                        value: `${group_name},${group_name1}`,
                        count: index_standards1.length
                    });
                }
                if (children1.length) {
                    //三级
                    for (const item2 in children1) {
                        const { group_name: group_name2, group_name_en: group_name2_en, index_standards: index_standards2 } = children1[item2]
                        if (index_standards2.length) {
                            // data_all[`${group_name},${group_name1},${group_name2}`] = index_standards2
                            index_standards2.forEach(element => {
                                element.groupTypeName = `${group_name},${group_name1},${group_name2}`
                                element.groupTypeName_en = `${group_name_en},${group_name1_en},${group_name2_en}`
                            })
                            data_all = [...index_standards2, ...data_all]
                            key_all.push({
                                label: `${group_name},${group_name1},${group_name2}`,
                                label_en: `${group_name_en},${group_name1_en},${group_name2_en}`,
                                value: `${group_name},${group_name1},${group_name2}`,
                                count: index_standards2.length
                            });
                        }
                    }
                }
            }
        }
    }
    groupTypeList.value = [...key_all]
    tableAllInfo.value = [...data_all]
}

const makeData = (data) => {
    // 设置组list
    if (data.index_standards && Object.keys(data.index_standards).length) {
        tableAllInfo.value = [];
        groupTypeList.value = []
        set_key_data(data.index_standards)
        // for (let k in data.index_standards) {
        //     // 组list
        //     groupTypeList.value.push({
        //         label: k,
        //         value: k,
        //     })
        //     // 暂存全部数据
        //     for (let kk in data.index_standards[k]) {
        //         tableAllInfo.value.push(data.index_standards[k][kk]);
        //     }
        // }
        // 设置分页数据
        setTableData();

    } else {
        tableInfo.value = [];
        tableAllInfo.value = [];
    }
}

const setTableData = () => {
    // 根据分页
    // 根据group type name筛选  groupTypeName 是指标的三个父级组成的信息
    let startIndex = ((currentPage.value - 1) * pageSize.value) - 1 < 0 ? 0 : ((currentPage.value - 1) * pageSize.value);
    let endIndex = startIndex + pageSize.value;
    if (searchData.group) {
        // 按groupTypeName筛选数据
        let data = tableAllInfo.value.filter(item => item.groupTypeName == searchData.group)
        total.value = data.length
        tableInfo.value = data.slice(startIndex, endIndex)
    } else {
        total.value = tableAllInfo.value.length
        tableInfo.value = tableAllInfo.value.slice(startIndex, endIndex)
    }
    // 显示prcie cycle值
    if (valueList.value.length && tableInfo.value.length) {
        // 匹配数据
        for (const item1 in tableInfo.value) {
            let arr = valueList.value.filter(item => item.index_standard_id == tableInfo.value[item1].id)
            if (arr.length) {
                tableInfo.value[item1].testPrcie = arr[0].price
                tableInfo.value[item1].testCycle = arr[0].cycle
            }
        }
    }

}

const getDataList = async () => {
    // 根据hscode查询数据
    if (searchData.hscode && searchData.hscode.length && searchData.hscode != null) {
        let id = [...searchData.hscode].pop()
        if (selectHscode.value == id && selectHscode.value && tableAllInfo.value.length) {
            // 根据组显示数据
            setTableData();
            return
        }
        const resp = await getHscodeDetail(id, {});
        if (resp.code == 0) {
            selectHscode.value = id
            searchData.group = ''
            // 组装数据
            makeData(resp.payload)
        }
    } else {
        tableInfo.value = [];
        tableAllInfo.value = [];
        total.value = 0;
    }

}
const getValueList = async () => {
    // 查询所有的指标prcie cycle
    const resp = await get_user_index_standard()
    if (resp.code == 0) {
        valueList.value = resp.payload
    }
}
const getHscodeList = async () => {
    // 查询hscode
    const resp = await getHscode()
    if (resp.code == 0) {
        hscodeList1.value = resp.payload
    }
}

const editTable = (i) => {
    // 编辑表格项
    tableInfo.value[i].showEdit = true;
    tableInfo.value[i].testPrcie1 = tableInfo.value[i].testPrcie;
    tableInfo.value[i].testCycle1 = tableInfo.value[i].testCycle;
}

const saveTable = async (i) => {
    // 保存信息
    let data = {
        index_standard_id: tableInfo.value[i].id,
        price: tableInfo.value[i].testPrcie1,
        cycle: tableInfo.value[i].testCycle1
    }
    let params = {
        index_standard: []
    }
    // 判断数据
    params.index_standard.push(data);
    // if (valueList.value.length == 0) {
    //     params.index_standard.push(data);
    // } else {
    //     // 判断是否已经有这条数据
    //     let xx = false;
    //     // 存在就修改，不存在就添加
    //     // 先判断是否存在，存在就修改，不存在就添加
    //     // 存在就修改，不存在就添加
    //     for (let i = 0; i < valueList.value.length; i++) {
    //         if (valueList.value[i].index_standard_id == data.index_standard_id) {
    //             valueList.value[i] = data;
    //             xx = true;
    //             break;
    //         }
    //     }
    //     if (!xx) {
    //         valueList.value.push(data);
    //     }
    //     // 上传数据
    //     params.index_standard = valueList;
    // }
    let xx = true
    if (xx) {
        const resp = await post_user_index_standard(params);
        if (resp.code == 0) {
            showMessage('success', getLangValue("base.success"))
            tableInfo.value[i].showEdit = false;
            // 重新刷新数据
            await getValueList();
            setTableData();
        } else {
            showMessage('danger', resp.message)
        }
    }


}
const cancelTable = (i) => {
    // 编辑表格项
    tableInfo.value[i].showEdit = false;
}


watch(pageSize, () => {
    currentPage.value = 1;
    setTableData()
})


watch(currentPage, () => {
    setTableData();
})


onMounted(() => {
    // getDataList();
    getValueList();
    getHscodeList();
    // getGroupList();
})

</script>
<style scoped lang="scss">
.my-select {
    :deep(.el-select__wrapper) {
        min-height: unset !important;
        height: 100% !important;
    }

    :deep(.el-input--suffix) {
        height: 100% !important;
    }

}
</style>
<style lang="scss">
.el-cascader-panel {
    .el-radio {
        margin-bottom: unset !important;
    }
}
</style>
<template>
    <div class="testTable h-100">
        <div class="search py-2 d-flex align-items-center justify-content-between ">
            <!-- 企业类型 -->
            <div style="flex: 1;" class=" d-flex align-items-center">
                <!-- <el-select v-model="searchData.type" style="width: 252px; height: 38px;"
                    :placeholder="$t('product_line.searchPlaceholder1')" size="large" clearable>
                    <el-option v-for="(item, key) in typelist" :key="key" :label="item.name" :value="item.name" />
                </el-select> -->
                <!-- hscode -->
                <div class="my-select mx-2">
                    <el-cascader filterable size="large" v-model="searchData.hscode" style="width: 100%;height: 38px;"
                        :options="hscodeList1"
                        :props="{ label:  i18n.global.locale === 'en' ? 'title_en' : 'title', value: 'id', children: 'children', checkStrictly: true, }"
                        placeholder="HS Code" clearable class="my-el" />
                </div>
                <el-select v-model="searchData.group" style="width: 252px; height: 38px;"
                    :placeholder="getLangValue('my.account', 'indicator_group')" size="large" clearable>
                    <el-option v-for="(item, key) in groupTypeList" :key="key" :label="item.label" :value="item.value">
                        <span style="float: left">{{ i18n.global.locale === 'en' ? item.label_en : item.label }}</span>
                        <span style="float: right; color: var(--el-text-color-secondary);font-size: 13px;">
                            {{ item.count }}
                        </span>
                    </el-option>
                </el-select>
            </div>
            <!-- 按钮 -->
            <b-button variant="success" @click="search"
                style="min-width: 100px; background-color: #405189;display: flex;align-items: center; border-color: unset; justify-content: center;">
                <i class="ri-search-line me-1"></i>{{ getLangValue('base.search') }}
            </b-button>
            <b-button class="mx-2" variant="success" @click="reset"
                style="min-width: 100px;background-color: #299CDB;display: flex;align-items: center;border-color: unset; justify-content: center; ">
                <i class="ri-refresh-line me-1"></i> {{ getLangValue('base.reset') }}
            </b-button>
        </div>
        <!-- 分页信息 -->
        <div class="my-scroll-bar" style="height:calc(100% - 60px - 54px); overflow-y: auto;">
            <table class="table table-bordered table-nowrap " v-loading="loading">
                <thead class="table-light ">
                    <tr>
                        <!--  -->
                        <th scope="col" v-for="(head, index) in table_head" :key="index" style="color: #9599AD;"
                            :width="head.width">
                            <div class="d-flex align-items-center" style="height: 36px;">
                                {{ head.label }}
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle">
                        <td style="word-wrap: break-word;white-space:normal;">{{  i18n.global.locale === 'en' ? info.name_en : info.name }}</td>
                        <td style="word-wrap: break-word;white-space:normal;">{{  i18n.global.locale === 'en' ? info.groupTypeName_en : info.groupTypeName }}</td>
                        <td style="word-wrap: break-word;white-space:normal;">{{  i18n.global.locale === 'en' ? info.reference_en : info.reference }}</td>
                        <td>
                            <input v-if="info.showEdit" style="width: 100%" type="text" class="form-control"
                                v-model="info.testPrcie1" />
                            <span v-else>{{ info.testPrcie }}</span>
                        </td>
                        <td>
                            <input v-if="info.showEdit" style="width: 100%" type="text" class="form-control"
                                v-model="info.testCycle1" />
                            <span v-else>{{ info.testCycle }}</span>
                        </td>
                        <td>
                            <ul class=" list-inline hstack gap-2 mb-0">
                                <li class="list-inline-item cursor" v-permit="'my.account.modify'" v-if="info.showEdit">
                                    <div class="text-primary d-inline-block" @click="saveTable(index)">
                                        <i class="fs-16 ri-check-fill"></i>
                                    </div>
                                </li>
                                <li class="list-inline-item cursor" v-if="info.showEdit">
                                    <div class="text-primary d-inline-block" @click="cancelTable(index)">
                                        <i class="fs-16 ri-close-fill"></i>
                                    </div>
                                </li>
                                <li class="list-inline-item cursor" v-permit="'my.account.modify'" v-else>
                                    <div class="text-primary d-inline-block" @click="editTable(index)">
                                        <i class="fs-16 ri-pencil-fill"></i>
                                    </div>
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- </div> -->
        <!-- 分页 -->
        <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
            :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5">
        </Pagination>
    </div>

</template>
<style scoped lang="scss">
:deep(.el-select__placeholder.is-transparent) {
    font-size: 0.8125rem;
    color: #878a99 !important;
}

:deep(.el-select__selected-item.el-select__placeholder) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner::placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-webkit-input-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-ms-input-placeholder) {
    color: #878a99;
}
</style>